<template lang="pug">
  router-link(v-bind="$attrs", @mousedown.native="onClick", @touchstart.native="onClick")
    slot
</template>

<script>
export default {
  name: 'ArticleLink',
  methods: {
    onClick () {
      this.$store.commit('SET_PAGE_TRANSITION', 'openbook')
      // reset
      setTimeout(() => {
        this.$store.commit('SET_PAGE_TRANSITION')
      }, 400) // long enough so LibraryCategoriesMenu.vue doesn't appear
    }
  }
}
</script>

<style>
</style>
